// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qrSF","top":"styles_top__18C8_"};